import React, { useState, useEffect, useContext } from "react";
import ReactEcharts from "echarts-for-react";
import { SizeContext } from "layouts/AppMain";

type DataType = {
  name: string;
  value: number;
};

interface RosePieProps {
  data: DataType[];
}

const getOption = (
  data: DataType[] = [],
  s: (n: number, b?: boolean) => number
) => {
  var option = {
    title: [
      ...data
        .map((d, i) => [
          {
            text: d.name,
            left: ["25%", "75%"][i],
            bottom: "5%",
            padding: [0, 0],
            textAlign: "center",
            textStyle: {
              fontSize: s(16),
              fontWeight: "normal",
              fontFamily: "FZLanTingHei",
              color: "#fff",
            },
          },
          {
            text: `${(
              (d.value / data.reduce((a, b) => a + b.value, 0)) *
              100
            ).toFixed(1)}%`,
            left: ["24%", "74%"][i],
            top: "center",
            textAlign: "center",
            textStyle: {
              fontSize: s(24),
              fontWeight: "normal",
              fontFamily: "DIN",
              color: "#fff",
            },
          },
        ])
        .reduce((a, b) => a.concat(b), []),
    ],
    series: [
      ...data
        .map((d, i) => [
          {
            type: "pie",
            hoverAnimation: false,
            center: [["25%", "75%"][i], "50%"],
            radius: ["50%", "60%"],
            label: {
              show: false,
            },
            clockwise: i === 0,
            silent: true,
            data: data.map((e, j) =>
              Object.assign(
                {
                  itemStyle: {
                    color: i === j ? ["#7ff4f7", "#bd40a4"][i] : "#1d1d67",
                  },
                },
                e
              )
            ),
          },
          // 外边框虚线
          {
            type: "pie",
            center: [["25%", "75%"][i], "50%"],
            radius: ["70%", "72%"],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            silent: true,
            data: Array.from({ length: 32 })
              .map((e, y) => [
                {
                  value: 20,
                  itemStyle: {
                    color:
                      y / 32 < d.value / data.reduce((a, b) => a + b.value, 0)
                        ? ["#7ff4f7", "#bd40a4"][i]
                        : "#1d1d67",
                    borderWidth: 0,
                    borderColor: "transparent",
                  },
                },
                {
                  value: 80,
                  itemStyle: {
                    color: "transparent",
                    borderWidth: 0,
                    borderColor: "transparent",
                  },
                },
              ])
              .reduce((a, b) => a.concat(b), []),
          },
        ])
        .reduce((a, b) => a.concat(b), []),
    ],
  };

  return option;
};

const RosePie: React.FC<RosePieProps> = ({ data }) => {
  const getSize = useContext(SizeContext);
  const [option, setOption] = useState<any>({});

  useEffect(() => {
    setOption(getOption(data, getSize));
  }, [data, getSize]);

  return (
    <ReactEcharts
      option={option}
      notMerge={true}
      style={{ width: "100%", height: "100%", position: "absolute" }}
    />
  );
};

export default RosePie;
